import React, { FC, useEffect } from 'react';

import { Loader } from '../../components/Loader';
import { useAuth } from '../../utils/hooks';

const ResetPasswordPage: FC = () => {
  const { loginWithRedirect, isInitialized } = useAuth();

  useEffect(() => {
    if (isInitialized) {
      loginWithRedirect({
        redirectUri: `/home`,
        mode: 'forgotPassword',
        isDirectUrl: true,
      });
    }
  }, [isInitialized, loginWithRedirect]);

  return <Loader />;
};

export default ResetPasswordPage;
